import React from 'react';
import { EmptyState } from '@spark';
import TaskPageTabEmpty from '@/features/tasks/components/TaskPageTabEmpty';

/**
 * Evaluations tab empty state — shared TaskPageTabEmpty chrome as Model Summary
 * / Data Editor (Figma 3001-71663).
 */
const EvaluationEmptyState = () => (
    <TaskPageTabEmpty>
        <EmptyState
            title="An overview will appear here"
            subtitle="Once you have models, statistics will appear here."
            showSubtitle
        />
    </TaskPageTabEmpty>
);

export default EvaluationEmptyState;
